import PropTypes from "prop-types";
import React from "react";

import { Text, textPropTypes } from "@swa-ui/core";
import i18n from "@swa-ui/locale";

/**
 * Gate renders the flight gate identifier.
 */
export const Gate = (props) => {
  const { className, gate, textProps } = props;

  return (
    <Text className={className} element="span" {...textProps}>
      {i18n("Gate__GATE", { gate })}
    </Text>
  );
};

Gate.propTypes = {
  /**
   * Additional classes for positioning the component. Given classes may only position this
   * component for layout purposes, and cannot change how the component renders in any way.
   */
  className: PropTypes.string,

  /** The gate identifier, such as 23 or "A12". */
  gate: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /** Props passed to the underlying Text component. See Text for more details. */
  textProps: PropTypes.shape(textPropTypes),
};
